import { DISCOVERY_LAB_LAYOUT } from '../DiscoveryLabConfig.js';
import {
  getSceneResponsiveLayout,
  type LogicalBounds,
  type ResponsiveLayoutConfig,
} from '../../../shared/layout/index.js';

export type DiscoveryLabSafeBounds = LogicalBounds;

export const DISCOVERY_LAB_RESPONSIVE_LAYOUT: ResponsiveLayoutConfig = {
  logicalSize: { width: DISCOVERY_LAB_LAYOUT.width, height: DISCOVERY_LAB_LAYOUT.height },
  visibilityScaleMode: 'envelop',
  safeInsets: { top: 16, right: 16, bottom: 16, left: 16 },
  compactViewportHeight: DISCOVERY_LAB_LAYOUT.compactViewportHeight,
  compactVisibleHeight: 690,
};

export function calculateDiscoveryLabSafeBounds(scene: Phaser.Scene): DiscoveryLabSafeBounds {
  return getSceneResponsiveLayout(scene, DISCOVERY_LAB_RESPONSIVE_LAYOUT).safe;
}

export function isCompactDiscoveryLabLayout(
  scene: Phaser.Scene,
  safeBounds = calculateDiscoveryLabSafeBounds(scene),
) {
  void safeBounds;
  return getSceneResponsiveLayout(scene, DISCOVERY_LAB_RESPONSIVE_LAYOUT).compact;
}
